export const TOKEN_NAME = "gymgoerAdminToken";
export const STORE_NAME = "gymgoerAdminStore";
export const SESSION_NAME = "gymgoerAdminSession";
export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";
import defaultAvatar from "@/assets/images/default-avatar.png";
import largeAvatar from "@/assets/images/large-avatar.png";
export const DEAFAULT_AVATAR = defaultAvatar;
export const LARGE_AVATAR = largeAvatar;
